var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.308,
    height: 16,
    viewBox: "0 0 8.308 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "f_1_",
    d: "M42.683,16V8.7h2.449L45.5,5.857H42.683V4.041c0-.823.228-1.385,1.41-1.385H45.6V.111A20.41,20.41,0,0,0,43.4,0a3.427,3.427,0,0,0-3.658,3.759v2.1H37.29V8.7h2.456V16Z",
    transform: "translate(-37.29)",
    fill: "#e4002f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c0b66eabbf050417c5a511106b8b0b57.svg";
export { ForwardRef as ReactComponent };